import { Signal, inject, computed } from '@angular/core';
import { GrowthBookService } from '@lentau/core/growth-book/shared/growth-book.service';
import { GrowthBookValue } from '@lentau/core/growth-book/shared/growth-book.enums';
import { PlatformService } from '@lentau/ui-kit/core/services/platform/platform.service';
import { IS_OKEY_APP } from '@lentau/ui-kit/core/tokens/is-okey-app';

export const authTokenExperiment: string = 'exp_br_1521_refresh_auth_token';

export const isAuthTokenExperiment: () => Signal<boolean> = () => {
  const growthBookService: GrowthBookService = inject(GrowthBookService);
  const platformService: PlatformService = inject(PlatformService);

  return computed(
    () =>
      (platformService.isServer || growthBookService.isInitialized()) &&
      growthBookService.checkFeature(authTokenExperiment, GrowthBookValue.Test)
  );
};

export const authCallExperiment: string = 'exp_auth_call';

export const isAuthCallExperiment: () => Signal<boolean> = () => {
  const growthBookService: GrowthBookService = inject(GrowthBookService);
  const platformService: PlatformService = inject(PlatformService);
  const isOkeyApp: boolean = inject(IS_OKEY_APP);

  return computed(
    () =>
      !isOkeyApp &&
      (platformService.isServer || growthBookService.isInitialized()) &&
      (growthBookService.checkFeature(authCallExperiment, GrowthBookValue.Test_A) ||
        growthBookService.checkFeature(authCallExperiment, GrowthBookValue.Test_B))
  );
};

export const isAuthCallExperimentA: () => Signal<boolean> = () => {
  const growthBookService: GrowthBookService = inject(GrowthBookService);
  const platformService: PlatformService = inject(PlatformService);
  const isOkeyApp: boolean = inject(IS_OKEY_APP);

  return computed(
    () =>
      !isOkeyApp &&
      (platformService.isServer || growthBookService.isInitialized()) &&
      growthBookService.checkFeature(authCallExperiment, GrowthBookValue.Test_A)
  );
};

export const isAuthCallExperimentB: () => Signal<boolean> = () => {
  const growthBookService: GrowthBookService = inject(GrowthBookService);
  const platformService: PlatformService = inject(PlatformService);
  const isOkeyApp: boolean = inject(IS_OKEY_APP);

  return computed(
    () =>
      !isOkeyApp &&
      (platformService.isServer || growthBookService.isInitialized()) &&
      growthBookService.checkFeature(authCallExperiment, GrowthBookValue.Test_B)
  );
};

export const permissionAdvCommunicationsToggle: string = 'permission_adv_communications';

export const isPermissionAdvCommunicationsEnabled: () => Signal<boolean> = () => {
  const growthBookService: GrowthBookService = inject(GrowthBookService);

  return computed(
    () =>
      growthBookService.isInitialized() &&
      growthBookService.checkFeature(permissionAdvCommunicationsToggle, true)
  );
};

/** GR-2751: лёгкие способы авторизации (VK ID / Яндекс ID) */
export const socialAuthMethodExperiment: string = 'exp_gr_2584_auth_vk_id_yandex_id';

export type SocialAuthMethodVariant = GrowthBookValue.Test_A | GrowthBookValue.Test_B | GrowthBookValue.Test_C | null;

export const getSocialAuthMethodVariant: () => Signal<SocialAuthMethodVariant> = () => {
  const growthBookService: GrowthBookService = inject(GrowthBookService);
  const platformService: PlatformService = inject(PlatformService);
  const isOkeyApp: boolean = inject(IS_OKEY_APP);

  return computed((): SocialAuthMethodVariant => {
    if (isOkeyApp) return null;
    if (!(platformService.isServer || growthBookService.isInitialized())) return null;

    if (growthBookService.checkFeature(socialAuthMethodExperiment, GrowthBookValue.Test_A)) {
      return GrowthBookValue.Test_A;
    }
    if (growthBookService.checkFeature(socialAuthMethodExperiment, GrowthBookValue.Test_B)) {
      return GrowthBookValue.Test_B;
    }
    if (growthBookService.checkFeature(socialAuthMethodExperiment, GrowthBookValue.Test_C)) {
      return GrowthBookValue.Test_C;
    }

    return null;
  });
};

export const isSocialAuthMethodExperiment: () => Signal<boolean> = () => {
  const variant: Signal<SocialAuthMethodVariant> = getSocialAuthMethodVariant();
  return computed(() => variant() !== null);
};
